// Turn a raw order_stats row (items + optional structured lines) into ticket
// lines where `paid` is what the customer actually paid for that line,
// toppings and quantity included. Mirrors backend/services/orderAlerts.js
// toLines() for screens that read the stats API directly.
const round = (v) => Math.round(v * 100) / 100;

export function paidLines(row) {
  const sel = row && row.lines && Array.isArray(row.lines.sel) ? row.lines.sel : null;
  if (sel && sel.length) {
    // Toast: p is the extended line total including modifiers.
    return sel.map(s => {
      const qty = Number(s.q) || 1;
      const paid = round(Number(s.p) || 0);
      return { name: s.n, quantity: qty, paid, note: s.note || null, mods: (s.mods || []).map(m => ({ name: m.n, price: Number(m.p) || 0 })) };
    });
  }
  const out = [];
  for (const it of (row && row.items) || []) {
    const qty = Number(it.quantity) || 1;
    const price = Number(it.price) || 0;
    const isMod = out.length > 0 && price === 0 && !/burrito|bowl|taco|quesadilla|nacho|salad|chips|coke|soda|cake/i.test(it.name || '');
    if (isMod) out[out.length - 1].mods.push({ name: it.name, price: 0 });
    else out.push({ name: it.name, quantity: qty, paid: round(price * qty), mods: [] });
  }
  return out;
}
